<template>
  <div class="counterparty-page">
    <CounterpartyWrapper />
  </div>
</template>

<script>
import CounterpartyWrapper from '@/wrappers/CounterpartyWrapper.vue';
export default {
  name: 'CounterpartyPage',
  components: {
    CounterpartyWrapper,
  },
  data() {
    return {
        // Define your component data here
    };
  },
  methods: {
    // Add your methods here
  },
  computed: {
    // Add your computed properties here
  },
  mounted() {
    // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
.counterparty-page {
  /* Add your styles here */
}
</style>